import { Divider, Image, List, Tooltip, Typography } from 'antd';
import { logo, MapMarkerIcon, UserIcon } from 'assets';
import dayjs from 'dayjs';
import { requestform } from 'messages';
import React from 'react';
import { TicketDto } from 'types/dto/ticket';

const ContactCompletedTicketItem: React.FC<{
  item: TicketDto;
  showModal: (ticketId: number, secondCall?: boolean) => void;
  handleCustomerCodeClick?: (customerCode: string) => void;
}> = ({ item, showModal, handleCustomerCodeClick }) => {
  return (
    <List.Item className='' key={item.ticketId} onClick={() => showModal(item.ticketId)}>
      <div className='flex flex-row space-x-5'>
        <div className='mt-2 flex flex-col'>
          <Typography.Text className='text-nowrap text-center text-[14px]/[18px] font-semibold tracking-normal text-[#1564E8] opacity-100'>
            ID : {item?.ticketId}
          </Typography.Text>
          <Typography.Text className='text-nowrap text-left font-oswald text-[18px]/[22px] tracking-normal text-[#141414] opacity-100'>
            {dayjs(item?.createdAt).format('DD/MM/YYYY')}
          </Typography.Text>
          <Typography.Text className='mt-1 text-nowrap text-center font-oswald text-[12px]/[16px] tracking-normal text-[#868D97] opacity-100'>
            {dayjs(item?.createdAt).format('HH:mm')}
          </Typography.Text>
        </div>
        <Divider style={{ borderColor: '#FF9500', borderWidth: 1 }} className='h-[72px]' type='vertical' />
        <div className='flex flex-col gap-1'>
          <div className='flex flex-col gap-1'>
            <div className='flex flex-row gap-2'>
              <Typography.Text className='text-left text-base/[18px] font-semibold tracking-normal text-[#181818] opacity-100'>
                {item?.serviceType.name}
              </Typography.Text>
            </div>

            <div className='flex flex-wrap items-center gap-2'>
              <UserIcon className='h-[16px] w-[16px] bg-transparent bg-no-repeat bg-origin-padding opacity-100' />
              <Tooltip title={item?.customerRequestName}>
                <span className='text-left text-base/[18px] tracking-normal text-[#181818] opacity-100'>
                  {item?.customerRequestName}
                </span>
              </Tooltip>
              <Typography.Text className='relative -top-1.5 text-[24px]/[24px] font-bold'>.</Typography.Text>
              <div className='flex flex-row gap-2'>
                <Image
                  src={logo}
                  alt='logoEVN'
                  className='mt-0.5 h-[16px] w-[16px] bg-transparent bg-no-repeat bg-origin-padding opacity-100'
                />
                <span
                  className={`cursor-pointer rounded px-1 py-0.5 text-left text-[14px]/[18px] tracking-normal text-[#4D5664] opacity-100 transition-all duration-150 hover:bg-[#74cde4] hover:underline ${
                    item?.customerCode === 'khongdinhdanh' ? 'pointer-events-none opacity-50' : ''
                  }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCustomerCodeClick?.(item.customerCode);
                  }}
                >
                  {item?.customerCode}
                </span>
              </div>
              <Typography.Text className='relative -top-1.5 text-[24px]/[24px] font-bold'>.</Typography.Text>
              <div className='mt-0.5 flex flex-row items-center gap-2'>
                <MapMarkerIcon className='h-[16] w-[16px] bg-transparent bg-no-repeat bg-origin-padding opacity-100' />
                <Tooltip title={item?.customerRequestAddress}>
                  <span className='text-left text-base/[18px] tracking-normal text-[#141414] opacity-100'>
                    {item?.customerRequestAddress}
                  </span>
                </Tooltip>
              </div>
            </div>

            <div className='flex h-4 space-x-4'>
              <Typography.Text
                className={`text-[14px]/[18px] font-normal italic ${
                  item?.numOfRequests > 5
                    ? 'text-[#D1131D]'
                    : item?.numOfRequests > 3
                      ? 'text-[#FF9500]'
                      : 'text-[#6C737E]'
                }`}
              >
                {requestform?.numOfRequest} {item?.numOfRequests} {requestform?.numContacts}
              </Typography.Text>

              {item?.ticketDistributions?.find(
                (ticketDistribution) => ticketDistribution?.isPrimary === true && ticketDistribution.isActive === 1
              )?.primaryTeamName && (
                <div>
                  <Typography.Text className='relative bottom-3.5 mx-2 ml-3 text-2xl font-bold'>.</Typography.Text>
                  <Typography.Text className='relative bottom-2.5 text-[14px]/[18px] italic text-[#6C737E]'>
                    {requestform.responsibleOrganizationUnit}
                    {
                      item?.ticketDistributions?.find(
                        (ticketDistribution) =>
                          ticketDistribution?.isPrimary === true && ticketDistribution.isActive === 1
                      )?.primaryTeamName
                    }
                  </Typography.Text>
                </div>
              )}

              {item?.ticketDistributions?.find(
                (ticketDistribution) =>
                  ticketDistribution?.isPrimary === true && ticketDistribution?.assigneeId !== null
              )?.assigneeId && (
                <div>
                  <Typography.Text className='relative bottom-3.5 mx-2 ml-3 text-2xl font-bold'>.</Typography.Text>
                  <Typography.Text className='relative bottom-2.5 text-[14px]/[18px] italic text-[#02D8A0]'>
                    {requestform.assigneeEmployee}
                    {
                      item?.ticketDistributions?.find(
                        (ticketDistribution) =>
                          ticketDistribution?.isPrimary === true && ticketDistribution?.assigneeId !== null
                      )?.assigneeName
                    }
                  </Typography.Text>
                </div>
              )}
              {/* <div
                             className="hover:bg-[#59a2c4] cursor-pointer p-2.5 rounded"
                             onClick={(e) => {
                               e.stopPropagation();
                               showModal(item?.ticketId, true);
                             }}
                           >
                             <Typography.Text className="text-left relative bottom-2.5 text-[14px]/[18px] italic tracking-normal text-[#1564E8] opacity-100">
                               {item.numOfRequests !== null ? `Gọi lần ${(item.numOfRequests) + 1}` : 'Gọi lần 2'}
                             </Typography.Text>
                           </div> */}
            </div>
          </div>
        </div>
      </div>
    </List.Item>
  );
};

export default ContactCompletedTicketItem;
